module.exports = __webpack_public_path__ + "img/plus-solid.41ae606f.svg";